import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

import { H3, P } from '@mxenabled/mxui'
import { ChevronRight, MultilineChart } from '@mxenabled/mx-icons'

import { Loader, useGlobalCopyStore, useGlobalUiStore } from '../../common'

interface MissingDataProps {
  onClick: () => void
}

const MissingData = ({ onClick }: MissingDataProps) => {
  const { finstrong: copy } = useGlobalCopyStore()
  const { isCopyLoaded } = useGlobalUiStore()

  if (!isCopyLoaded) return <Loader />

  return (
    <Stack sx={{ alignItems: 'center', gap: 12, pt: 12, pb: 32 }}>
      <MultilineChart size={48} />

      <Stack sx={{ alignItems: 'center', gap: 4, textAlign: 'center' }}>
        <H3>{copy.missing_data_title}</H3>
        <P sx={{ width: { sm: 348 } }} variant="subtitle1">
          {copy.missing_data_description}
        </P>
      </Stack>
      <Box>
        <Button
          endIcon={<ChevronRight />}
          onClick={onClick}
          size="small"
          sx={{
            fontSize: 13,
            ':hover': {
              bgcolor: 'transparent',
            },
          }}
          variant="text"
        >
          {copy.connect_more_accounts_button}
        </Button>
      </Box>
    </Stack>
  )
}

export default observer(MissingData)
